module.exports = __webpack_public_path__ + "img/map-pin-2-fill.c58cc476.svg";